import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4281030b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-accr" }
const _hoisted_2 = { class: "nge-accr-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Access requests", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-accr-sub" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  class: "nge-accr-filters",
  role: "tablist"
}
const _hoisted_7 = ["aria-selected", "onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "nge-accr-retina" }, "Retina requests", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-accr-how" }, " Each player sends 7 cuts (red and blue Multicut points where they would cut) and 3 merges (merge points on the two pieces), placed but not submitted. Open an example in the view to judge every point, mark it good or redo, then ask for redos or grant edit access. ", -1 /* HOISTED */))
const _hoisted_10 = {
  key: 0,
  class: "nge-accr-err",
  role: "alert"
}
const _hoisted_11 = {
  key: 1,
  class: "nge-accr-how"
}
const _hoisted_12 = {
  key: 2,
  class: "nge-accr-how"
}
const _hoisted_13 = ["aria-expanded", "onClick"]
const _hoisted_14 = { class: "nge-accr-name" }
const _hoisted_15 = { class: "nge-accr-meta" }
const _hoisted_16 = { class: "nge-accr-meta" }
const _hoisted_17 = { class: "nge-accr-status" }
const _hoisted_18 = { class: "nge-accr-tally" }
const _hoisted_19 = {
  key: 0,
  class: "nge-accr-body"
}
const _hoisted_20 = {
  key: 0,
  class: "nge-accr-waiting"
}
const _hoisted_21 = {
  key: 1,
  class: "nge-accr-note"
}
const _hoisted_22 = { class: "nge-accr-table" }
const _hoisted_23 = { class: "nge-accr-kind" }
const _hoisted_24 = {
  key: 0,
  class: "nge-accr-new"
}
const _hoisted_25 = {
  key: 0,
  class: "nge-accr-marks"
}
const _hoisted_26 = {
  key: 1,
  class: "nge-accr-note"
}
const _hoisted_27 = {
  key: 2,
  class: "nge-accr-note nge-accr-note--you"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 4,
  class: "nge-accr-earlier"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 0,
  class: "nge-accr-note"
}
const _hoisted_32 = {
  key: 1,
  class: "nge-accr-note nge-accr-note--you"
}
const _hoisted_33 = { class: "nge-accr-acts" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["href"]
const _hoisted_36 = ["disabled", "onClick"]
const _hoisted_37 = ["disabled", "onClick"]
const _hoisted_38 = {
  key: 2,
  class: "nge-accr-decide"
}
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = { class: "nge-accr-cave" }
const _hoisted_41 = { class: "nge-accr-decide-btns" }
const _hoisted_42 = ["disabled", "onClick"]
const _hoisted_43 = ["disabled", "onClick"]
const _hoisted_44 = ["disabled", "onClick"]
const _hoisted_45 = {
  key: 3,
  class: "nge-accr-done",
  role: "status"
}
const _hoisted_46 = {
  key: 4,
  class: "nge-accr-done"
}
const _hoisted_47 = {
  key: 5,
  class: "nge-accr-note nge-accr-note--you"
}
const _hoisted_48 = { class: "nge-accr-delete" }
const _hoisted_49 = ["disabled", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString($setup.waiting) + " waiting for a review", 1 /* TEXT */),
      _createElementVNode("button", {
        class: "nge-accr-filter nge-accr-refresh",
        disabled: $setup.loading,
        title: "Look for new requests",
        onClick: $setup.load
      }, "Refresh", 8 /* PROPS */, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.FILTERS, (f) => {
          return _createElementVNode("button", {
            key: f,
            class: _normalizeClass(["nge-accr-filter", { 'nge-accr-filter--on': $setup.filter === f }]),
            role: "tab",
            "aria-selected": $setup.filter === f,
            onClick: $event => ($setup.setFilter(f))
          }, _toDisplayString(f === 'open' ? 'Open' : f === 'submitted' ? 'Waiting' : f === 'invited' ? 'Granted' : 'All'), 11 /* TEXT, CLASS, PROPS */, _hoisted_7)
        }), 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    _createVNode($setup["DatasetRequestsList"]),
    _hoisted_8,
    _hoisted_9,
    ($setup.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.error), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Loading…"))
      : (!$setup.requests.length && !$setup.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, "No requests here."))
        : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.requests, (r) => {
      return (_openBlock(), _createElementBlock("article", {
        key: r.id,
        class: _normalizeClass(["nge-accr-card", `nge-accr-card--${r.status}`])
      }, [
        _createElementVNode("button", {
          class: "nge-accr-head",
          "aria-expanded": $setup.openId === r.id,
          onClick: $event => ($setup.openId = $setup.openId === r.id ? null : r.id)
        }, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(r.player_name || r.email), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_15, [
            _createTextVNode(_toDisplayString(r.email), 1 /* TEXT */),
            (r.eyewire_username)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" · EyeWire: " + _toDisplayString(r.eyewire_username), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (r.affiliation)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" · " + _toDisplayString(r.affiliation), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("span", _hoisted_16, [
            _createTextVNode("Sent " + _toDisplayString($setup.when(r.submitted_at)), 1 /* TEXT */),
            (r.tries > 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" · try " + _toDisplayString(r.tries), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("span", _hoisted_17, _toDisplayString($setup.statusWord[r.status] || r.status), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_18, _toDisplayString($setup.counts(r).good) + " good · " + _toDisplayString($setup.counts(r).redo) + " redo · " + _toDisplayString($setup.counts(r).open) + " to check", 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_13),
        ($setup.openId === r.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              ($setup.waitingLine(r))
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString($setup.waitingLine(r)), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (r.player_note)
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Player's note: " + _toDisplayString(r.player_note), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("table", _hoisted_22, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sorted(r), (it, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: it.id,
                      class: _normalizeClass({ 'nge-accr-row--good': it.verdict === 'good', 'nge-accr-row--redo': it.verdict === 'redo' })
                    }, [
                      _createElementVNode("td", _hoisted_23, [
                        _createTextVNode(_toDisplayString(it.kind === 'cut' ? 'Cut' : 'Merge') + " " + _toDisplayString(it.slot) + " ", 1 /* TEXT */),
                        ($setup.isNew(r, it))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "new since your review"))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString($setup.summary(it)) + " ", 1 /* TEXT */),
                        ($setup.markCount(it).good || $setup.markCount(it).off)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, " · points " + _toDisplayString($setup.markCount(it).good) + " good, " + _toDisplayString($setup.markCount(it).off) + " off ", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (it.note)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Player: " + _toDisplayString(it.note), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (it.feedback)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Note: " + _toDisplayString(it.feedback), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (it.earlier && it.earlier.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              class: "nge-accr-earlier-btn",
                              onClick: $event => ($setup.openEarlier[`${r.id}${it.kind}${it.slot}`] = !$setup.openEarlier[`${r.id}${it.kind}${it.slot}`])
                            }, _toDisplayString(it.earlier.length === 1 ? '1 earlier try' : `${it.earlier.length} earlier tries`) + " " + _toDisplayString($setup.openEarlier[`${r.id}${it.kind}${it.slot}`] ? '▴' : '▾'), 9 /* TEXT, PROPS */, _hoisted_28))
                          : _createCommentVNode("v-if", true),
                        ($setup.openEarlier[`${r.id}${it.kind}${it.slot}`])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it.earlier, (h, hi) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: hi,
                                  class: "nge-accr-earlier-row"
                                }, [
                                  _createElementVNode("span", null, [
                                    _createTextVNode("Try " + _toDisplayString(h.try || hi + 1) + ": " + _toDisplayString($setup.summary(h)), 1 /* TEXT */),
                                    (h.verdict)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(", marked " + _toDisplayString(h.verdict), 1 /* TEXT */)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("a", {
                                    class: "nge-accr-link",
                                    href: h.link,
                                    target: "_blank",
                                    rel: "noopener",
                                    title: "Open that earlier example in a new tab"
                                  }, "open ↗", 8 /* PROPS */, _hoisted_30),
                                  (h.note)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Player: " + _toDisplayString(h.note), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  (h.feedback)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Note: " + _toDisplayString(h.feedback), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("td", _hoisted_33, [
                        _createElementVNode("button", {
                          class: "nge-accr-btn",
                          onClick: $event => ($setup.reviewInView({ ...r, items: $setup.sorted(r) }, i))
                        }, "Review in the view", 8 /* PROPS */, _hoisted_34),
                        _createElementVNode("a", {
                          class: "nge-accr-link",
                          href: it.link,
                          target: "_blank",
                          rel: "noopener",
                          title: "Open the link in a new tab"
                        }, "↗", 8 /* PROPS */, _hoisted_35),
                        _createElementVNode("button", {
                          class: _normalizeClass(["nge-accr-btn nge-accr-btn--good", { 'nge-accr-btn--on': it.verdict === 'good' }]),
                          disabled: $setup.busy === `v${it.id}` || r.status !== 'submitted',
                          onClick: $event => ($setup.setVerdict(r, it, 'good'))
                        }, "Good", 10 /* CLASS, PROPS */, _hoisted_36),
                        _createElementVNode("button", {
                          class: _normalizeClass(["nge-accr-btn nge-accr-btn--redo", { 'nge-accr-btn--on': it.verdict === 'redo' }]),
                          disabled: $setup.busy === `v${it.id}` || r.status !== 'submitted',
                          onClick: $event => ($setup.setVerdict(r, it, 'redo'))
                        }, "Redo", 10 /* CLASS, PROPS */, _hoisted_37)
                      ])
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              (r.status === 'submitted')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("label", null, [
                      _createTextVNode("Note to " + _toDisplayString(r.player_name || 'the player') + " (optional, goes with your answer) ", 1 /* TEXT */),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": $event => (($setup.notes[r.id]) = $event),
                        rows: "3",
                        maxlength: "4000"
                      }, null, 8 /* PROPS */, _hoisted_39), [
                        [_vModelText, $setup.notes[r.id]]
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_40, [
                      _createTextVNode("Grant edit access adds "),
                      _createElementVNode("b", null, _toDisplayString(r.email), 1 /* TEXT */),
                      _createTextVNode(" to Eyewire_2_Edit in CAVE, then tells them. If CAVE says no, nothing is sent.")
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("button", {
                        class: "nge-accr-btn",
                        disabled: $setup.busy === `d${r.id}`,
                        onClick: $event => ($setup.decide(r, 'redo'))
                      }, "Ask for redos (" + _toDisplayString($setup.counts(r).redo) + ")", 9 /* TEXT, PROPS */, _hoisted_42),
                      _createElementVNode("button", {
                        class: "nge-accr-btn nge-accr-btn--invite",
                        disabled: $setup.busy === `d${r.id}`,
                        onClick: $event => ($setup.decide(r, 'invited'))
                      }, "Grant edit access", 8 /* PROPS */, _hoisted_43),
                      ($setup.needsHand[r.id])
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "nge-accr-btn",
                            disabled: $setup.busy === `d${r.id}`,
                            onClick: $event => ($setup.decide(r, 'invited', true)),
                            title: "Only after you added them to Eyewire_2_Edit in CAVE yourself"
                          }, "I added them by hand, grant", 8 /* PROPS */, _hoisted_44))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.done[r.id])
                ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString($setup.done[r.id]), 1 /* TEXT */))
                : (r.status === 'invited')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_46, " Access granted " + _toDisplayString($setup.when(r.reviewed_at)) + _toDisplayString(r.pilot_added ? ', added to the pilot testers' : '') + ". Their CAVE group (Eyewire_2_Edit) is given by hand. ", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
              (r.reviewer_note && r.status !== 'submitted')
                ? (_openBlock(), _createElementBlock("p", _hoisted_47, "Your note: " + _toDisplayString(r.reviewer_note), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("button", {
                  class: "nge-accr-btn",
                  disabled: $setup.busy === `x${r.id}`,
                  onClick: $event => ($setup.askingDelete = r.id)
                }, "Delete request", 8 /* PROPS */, _hoisted_49)
              ]),
              ($setup.askingDelete === r.id)
                ? (_openBlock(), _createBlock($setup["ConfirmDialog"], {
                    key: 6,
                    title: `Delete ${r.player_name || r.email}'s request?`,
                    text: `This deletes their ten examples and every mark and note on them, for good. It cannot be undone. They would have to start again from nothing.`,
                    yes: "Delete for good",
                    onYes: $event => ($setup.remove(r)),
                    onNo: _cache[0] || (_cache[0] = $event => ($setup.askingDelete = null))
                  }, null, 8 /* PROPS */, ["title", "text", "onYes"]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}